export const MAX_GAME_SLIDER_INLINE = 900;
export const MAX_MOBILE_VIEW = 800;
export const MAX_SLIDER_ARROW = 1150;

// TODO: add other reponsive values here
